
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function CancelOfertaModal({
    show, //bool mostrar modal o no
    onHide, //funcion para cerrar modal
    onConfirm, //funcion confirmar cancelar oferta
    oferta,
}) 
{
    const [loading, setLoading] = useState(false);

    //no hay oferta no muestra nada
    if (!oferta) return null;

    const normalizedState = oferta?.state;

    const confirmMessage = normalizedState === "contrato_enviado" 
        ? "Se intentara cancelar el envio en Signaturit. Si ya esta firmado, se continuara con la cancelacion de la oferta y deberas gestionar ATR fuera de circuito.\n\nLa oferta pasara a 'Oferta cancelada' y quedara bloqueada para edicion.\n\nDeseas continuar?"
        : "Se cancelara la oferta y quedara bloqueada para edicion.\n\nDeseas continuar?";

    //funcion para confirmar cancelacion oferta
    const handleConfirm = async () => {
        try {
            setLoading(true);
            await onConfirm(oferta);
            onHide();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered contentClassName="border-0 rounded-4 shadow-lg">
            <Modal.Header className="bg-white border-bottom-0" closeButton>
                <Modal.Title className="fw-bold text-primary">
                    Cancelar oferta
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-0">
                <div className="p-3 bg-light rounded-3 border border-light">
                    <p className="mb-0 text-muted" style={{ whiteSpace: "pre-line" }}>
                        {confirmMessage}
                    </p>
                </div>
            </Modal.Body>
            
            <Modal.Footer className="border-top-0 pt-2 pb-4">
                <Button
                    variant="outline-secondary"
                    className="rounded-pill px-4"
                    onClick={onHide}
                    disabled={loading}>
                    Cancelar
                </Button>

                <Button
                    variant="primary"
                    className="rounded-pill px-4 fw-bold shadow-sm"
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"></span>
                            Cancelando...
                        </>
                    ) : ("Sí, cancelar")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
